import { connect } from 'react-redux';
import { fetchMethodIfNeeded } from 'common/ducks/billing';
import PaymentMethod from 'common/components/payment_method';

const mapStateToProps = ({billing: {method}}) => ({
  method
})

export default connect(mapStateToProps, {
  fetchMethodIfNeeded
})(PaymentMethod);



// WEBPACK FOOTER //
// ./common/containers/payment_method.jsx